import {computed, reactive, watch} from "vue";
import Brands from "src/composables/Brands";
import Terms from "src/composables/Terms";
import Flags from "src/composables/Flags";
import Analytics from "src/composables/Analytics";


// Brands
const {clear_brand_selection, selected_brands} = Brands();

// Terms
const {clear_term_selection, available_terms, selected_terms} = Terms();

// Flags
const {only_100_percent_green, only_no_deposit, only_time_of_use, include_auto_pay} = Flags()

const clear_all_filters = function () {
    clear_brand_selection()
    clear_term_selection()
    only_time_of_use.value.selected = false;
    only_100_percent_green.value.selected = false;
    only_no_deposit.value.selected = false;
    include_auto_pay.value.selected = true;
}

const filters = reactive({
    selected_brands,
    selected_terms,
    only_100_percent_green,
    only_time_of_use,
    only_no_deposit,
    include_auto_pay
})

const combined_filters = computed(() => ({
  selected_brands_prop: selected_brands.value,
  selected_terms_prop: selected_terms.value,
  only_100_percent_green_prop: only_100_percent_green.value,
  only_time_of_use_prop: only_time_of_use.value,
  only_no_deposit_prop: only_no_deposit.value,
  include_auto_pay_prop: include_auto_pay.value
}));

const has_no_filters = computed(() => {
    return !selected_brands.value.length
        && !selected_terms.value.length
        && !only_100_percent_green.value.selected
        && !only_no_deposit.value.selected
        && !only_time_of_use.value.selected;
})


const has_long_term_filter = computed(() => {
    const long_term_options = available_terms.value.filter(x => x.value >= 12).map(x => x.value);
    if (filters.selected_terms.length) {
        return selected_terms.value.every(x => long_term_options.includes(x));
    }
    else {
        return false;
    }
})

const long_term_disabled = computed(() => {
    return !available_terms.value.some(x => x.value >= 12 && !x.disabled)
})

const filter_long_term = function () {
    clear_all_filters();
    const long_term_options = available_terms.value.filter(x => x.value >= 12).map(x => x.value);
    selected_terms.value = long_term_options;
}

const has_no_contract_filter = computed(() => {
    return selected_terms.value?.length === 1 && selected_terms.value[0] === 1;
})
const filter_no_contract = function () {
    clear_all_filters();
    selected_terms.value = [1];
}

const no_contract_disabled = computed(() => {
    return !available_terms.value.some(x => x.value === 1 && !x.disabled);
})

const {log_event} = Analytics();

watch(filters, () => {
    // console.log(newValue, oldValue)
    log_event({name: 'shop_select_filter', filters});
})

watch(selected_brands, () => {
    log_event({name: 'shop_select_provider', selected_brands});
})

watch(selected_terms, () => {
    log_event({name: 'shop_select_contract_length', selected_terms});
})

export default () => {

    return {
        filters,
        combined_filters,
        has_no_filters,
        has_long_term_filter,
        has_no_contract_filter,

        long_term_disabled,
        no_contract_disabled,

        clear_all_filters,
        filter_no_contract,
        filter_long_term
    }
}
